var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowAvatarBubble(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "20px",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLeftArrowCallAvatarBubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.07972519,10.1552336 L11.291365,2.95059406 C11.4899382,2.75269194 11.599177,2.48809178 11.599177,2.20595599 C11.599177,1.92366364 11.4899382,1.65922005 11.291365,1.46100479 L10.6594414,0.830035184 C10.4611816,0.631506783 10.1961561,0.522222222 9.91373395,0.522222222 C9.63131176,0.522222222 9.36659972,0.631506783 9.16818324,0.830035184 L0.581576801,9.40777727 C0.382376684,9.6066188 0.273294638,9.87231493 0.274078273,10.1547639 C0.273294638,10.4384653 0.382219957,10.7038483 0.581576801,10.9028464 L9.16019016,19.4722904 C9.35860664,19.6708188 9.62331868,19.7801034 9.9058976,19.7801034 C10.1883198,19.7801034 10.4530318,19.6708188 10.651605,19.4722904 L11.2833719,18.8413208 C11.694467,18.4306426 11.694467,17.7620966 11.2833719,17.351575 L4.07972519,10.1552336 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Outside-Incoming-call---Cancel",
    transform: "translate(-1035.000000, -1034.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1010.000000, 946.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(25.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLeftArrowCallAvatarBubble",
    transform: "translate(0.000000, 47.197674)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.111111, -15.337209)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 51 0 51 51 0 51"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowAvatarBubble);
export default __webpack_public_path__ + "static/media/icArrowAvatarBubble.5f1009e942a21e211dfd6773ee2b110d.svg";
export { ForwardRef as ReactComponent };